
import React, { Component, Fragment, useEffect, useState, useContext } from "react";

import useFetch from "../../helpers/useFetch";
import BiButton from "../../uic/controls/BiButton";
import BiLabel from "../../uic/controls/BiLabel";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid"
import { useNavigate } from 'react-router-dom';
import { SessionContext } from "../../../context/SessionProvider";
import BiAutoCB from "../../uic/controls/BiAutoCB";
import { httpGet } from "../../helpers/httpHelper";
import BiComboBox from "../../uic/controls/BiComboBox";
import authService from '../../api-authorization/AuthorizeService'
import BiTextBox from "../../uic/controls/BiTextBox";
import StatusObrazca from "../Obrazci/StatusObrazca";

const ObrazciAdmin = (props) => {
    const navigate = useNavigate();

    const { sessionReady, setLoading, toastError, toastOK, setHelpMainKey, isLoaded, setAdminFilter, adminFilter } = useContext(SessionContext)

    const [obrazci, setObrazci] = useState(null);
    const { data: statusi, setUrl: setUrlStat } = useFetch(null, true);
    const { data: tipobrazca, setUrl: setUrlTipObrazca } = useFetch(null, true);
    

    useEffect(() => {

       
        

        if (sessionReady) {
            setLoading(true);
            setUrlStat('api/sifranti/GetSifrantNA?all=true&ID=PSTATUSI');
            setUrlTipObrazca('api/sifranti/GetSifrantNA?all=true&ID=TIPOBRAZCA');

            if (adminFilter != null) {
                setFormData(adminFilter);
                loadEvents(adminFilter.stranka.id, adminFilter.status.id, adminFilter.leto, adminFilter.tipobrazca.id);
            } else {
                loadEvents(formData.stranka.id, formData.status.id, formData.leto, formData.tipobrazca.id);
            }
            
        }
    }, [sessionReady])
    useEffect(() => { setLoading(false); }, [isLoaded]);

 
    const [izbranObrazec, setIzbranObrazec] = useState(null);

    const [formData, setFormData] = useState({
        stranka: {
            naziv: "",
            id: null
        },
        status: {
            naziv: "",
            id: 3
        },
        tipobrazca: {
            naziv: "",
            id: null
        },
        leto: 2024 //new Date().getFullYear()
    });

    const formDataChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === "stranka") {
            loadEvents(value.id, formData.status.id, formData.leto, formData.tipobrazca.id);
        }
        else if (name === "status") {
            loadEvents(formData.stranka.id, value.id, formData.leto, formData.tipobrazca.id);
        }
        else if (name === "tipobrazca") {
            loadEvents(formData.stranka.id, formData.status.id, formData.leto, value.id);
        }
        else if (name === "leto") {
            loadEvents(formData.stranka.id, formData.status.id, value, formData.tipobrazca.id);
        }
    }

    const loadEvents = (stranka, status, leto, tipobrazca) => {
        setLoading(true);

        httpGet(
            "api/obrazci/GetObrazciAdmin",
            {
                IdStatus:status,
                IdStranke: stranka,
                leto: leto,
                IdTipObrazca: tipobrazca
            },
            function (ret) {
                setObrazci(ret);

                setLoading(false);
            }, authService);
    }


    const statusObrazca = (col, item) => {

        return <StatusObrazca status={item.pIdStatus } ></StatusObrazca>

    }
    const gumbIzpolni = (col, item) => {
        return <BiButton icon="fas fa-pen-to-square " onClick={()=>odpriObrazec(item)} >Odpri obrazec</BiButton>
    }

    const odpriObrazec = (obrazec) => {
        console.log(obrazec);
        setAdminFilter(formData);
        navigate('/UrejanjeObrazcaStranka', { replace: false, state: { pIdObrazca: obrazec.pIdObrazca } });
    

    }
    return (

        <Fragment >
            {obrazci && 
                <Fragment>

                    {/*<h2 id="tabelLabel" >Seznam vseh obrazcev</h2>*/}
                    {/*<p>Na seznamu so vsi obrazci za tekoče leto.</p>*/}

                    <div style={{ display: "flex", verticalAlign: "middle", alignItems: "center", marginBottom:"10px" }}>

                        <span style={{ marginRight: "6px", fontSize: "14px", }}><i className="fas fa-calendar" style={{ color: "gray", marginRight: "4px" }}></i>Leto: </span>
                        <BiTextBox width="55" name="leto" value={formData.leto} type="decimal" onChange={formDataChange}></BiTextBox>

                        <span style={{ marginRight: "6px", fontSize: "14px", marginLeft: "20px" }}><i className="fas fa-list" style={{ color: "gray", marginRight: "4px" }}></i>Status: </span>
                        <BiComboBox
                            online={false}
                            items={statusi}
                            width="150"
                            item={formData.status}
                            onItemSelected={formDataChange}
                            name="status">
                        </BiComboBox>

                        <span style={{ marginRight: "6px", fontSize: "14px", marginLeft: "20px" }}><i className="fas fa-users" style={{ color: "gray", marginRight: "4px" }}></i>Stranka: </span>
                        <BiAutoCB
                            online={true}
                            onlineID="STRANKE"
                            width="250"
                            placeholder="Iskanje po stranki"
                            item={formData.stranka}
                            onItemSelected={formDataChange}
                            name="stranka">
                        </BiAutoCB>

                        <span style={{ marginRight: "6px", fontSize: "14px", marginLeft: "20px" }}><i className="fa-brands fa-typo3" style={{ color: "gray", marginRight: "4px" }}></i>Tip obrazca: </span>
                        <BiComboBox
                            online={false}
                            items={tipobrazca}
                            width="200"
                            item={formData.tipobrazca}
                            onItemSelected={formDataChange}
                            name="tipobrazca">
                        </BiComboBox>

                        <span style={{ marginRight: "6px", fontSize: "14px", marginLeft: "20px" }}><i className="fa-solid fa-calculator" style={{ color: "gray", marginRight: "4px" }}></i>Št. zapisov: </span>
                        <BiTextBox width="55" name="skupaj" value={obrazci.length} type="decimal" readOnly></BiTextBox>
                    </div>

                    <div style={{ height: "calc(95vh - 160px)" }} >
                        <BiDataGrid
                            items={obrazci}
                            mainKey="pIdObrazca"
                            onSelectionChanged={(d) => setIzbranObrazec(d.pIdObrazca)}
                            columns={[
                                { label: "ID", key: "pIdObrazca", type: "decimal", width: "50px" },
                                { label: "Leto", key: "leto", type: "string", width: "50px" },
                                { label: "N", key: "prvaPrijava", type: "string", width: "30px"},
                                { label: "Status", key: "pIdStatus", type: "template", displayFunction: statusObrazca, width: "140px" },
                                { label: "Šif. pog.", key: "sifPogodbe", type: "string", width: "70px" },
                                { label: "Stranka", key: "nazivStranke", type: "string", width: "345px" },
                                { label: "Opis", key: "tipKontrole", type: "string", width: "200px" },
                                { label: "Tip", key: "nazivObrazca", type: "string", width: "150px" },
                                { label: "Datum oddaje", key: "datumOddaje", type: "date", width: "110px" },
                            
                                { label: "", key: null, type: "template", displayFunction: gumbIzpolni, width: "130px", cellStyle: { style: { padding: "0px" } } },
                                { width: "100%" },
                            ]}

                        ></BiDataGrid>
                    </div>
                </Fragment>
            
            }
        </Fragment>   
    );

}

export default ObrazciAdmin;